import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { InlineFieldLayout } from '../';

export const GroupLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  ${InlineFieldLayout}:not(:last-child) {
    margin-bottom: ${globalTheme.spacing.sm};
  }
`;

export const GroupLayout: FC = ({ children, ...rest }) => (
  <GroupLayoutWrapper {...rest}>
    {children}
  </GroupLayoutWrapper>
);
